
// https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes

const attributes = [
"accept",
"accept-charset",
"accesskey",
"action",
"align",
"allow",
"alt",
"async",
"autocapitalize",
"autocomplete",
"autofocus",
"autoplay",
"background",
"bgcolor",
"border",
"buffered",
"capture",
"challenge",
"charset",
"checked",
"cite",
"class",
"code",
"codebase",
"color",
"cols",
"colspan",
"content",
"contenteditable",
"contextmenu",
"controls",
"coords",
"crossorigin",
"csp",
"data",
"data-*",
"datetime",
"decoding",
"default",
"defer",
"dir",
"dirname",
"disabled",
"download",
"draggable",
"enctype",
"enterkeyhint",
"for",
"form",
"formaction",
"formenctype",
"formmethod",
"formnovalidate",
"formtarget",
"headers",
"height",
"hidden",
"high",
"href",
"hreflang",
"http-equiv",
"icon",
"id",
"importance",
"integrity",
"intrinsicsize",
"inputmode",
"ismap",
"itemprop",
"keytype",
"kind",
"label",
"lang",
"language",
"loading",
"list",
"loop",
"low",
"manifest",
"max",
"maxlength",
"minlength",
"media",
"method",
"min",
"multiple",
"muted",
"name",
"novalidate",
"open",
"optimum",
"pattern",
"ping",
"placeholder",
"poster",
"preload",
"radiogroup",
"readonly",
"referrerpolicy",
"rel",
"required",
"reversed",
"role",
"rows",
"rowspan",
"sandbox",
"scope",
"scoped",
"selected",
"shape",
"size",
"sizes",
"slot",
"span",
"spellcheck",
"src",
"srcdoc",
"srclang",
"srcset",
"start",
"step",
"style",
"summary",
"tabindex",
"target",
"title",
"translate",
"type",
"usemap",
"value",
"width",
"wrap",
]

export const removeIllegalAttributes = (whatsLeft, whatType) => {

    Object.keys(whatsLeft).forEach(k => {
        if (!attributes.includes(k)) {
            delete whatsLeft[k]
            console.log(`Removing ${k} prop from ${whatType}`);
        }
    })

}